<template>
  <div class="container-fluid search">
    <header>
      <base target="_blank"/>
    </header>
    <br>
    <div class="jumbotron align-center">
      <div class="row">
        <div class="col-8">
          <h3 style="color:#00B4CC;">Media Aggregator - Search your News </h3>
          <div class="search align-center row">
            <!-- <input id="version" type="text" class="form-control searchTerm" placeholder="Enter version of news" aria-label="Enter version of news" aria-describedby="button-addon2"> -->
            <div class="col-lg-11">
              <input id="searchTopic" type="text" class="form-control searchTerm" placeholder="Topic to retrieve news" aria-label="Topic to retrieve news" aria-describedby="button-addon2">
            </div>
          </div>
          <br>
          <div class="col-sm-auto">
              <button class="btn btn-xs" type="submit" id="searchButton" v-on:click="searchButton()">
                <i class="fa fa-search"></i>
              </button>
            </div>
        </div>
        <div class="row">
              <div class="col-8">
                  <h3 style="color:#00B4CC;">Start Date </h3>
                  <div class="search align-center">
                        <input id="startDate"  type="Date" class="form-control searchTerm" placeholder="dd-mm-yyyy" aria-label="Start Date" aria-describedby="button-addon2">
                  </div>
              </div>
              <div class="col-8">
                  <h3 style="color:#00B4CC;">End Date </h3>
                  <div class="search align-center">
                      <input id="endDate"  type="Date" class="form-control searchTerm" placeholder="dd-mm-yyyy" aria-label="End Date" aria-describedby="button-addon2">
                  </div>
              </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="list-group">
          <ul>
            <li
              is="resultItem"
              v-for="result in results"
              v-bind:key="result.guid"
              v-bind:title="result.title"
              v-bind:link="result.link"
              v-bind:pubDate="result.pubDate"
              v-bind:source="result.source"
              v-bind:result="result"
              v-on:checked="$store.commit('list/addArticle',$event)"
              class="list-group-item"
            >
            </li>
          </ul>
          <br>
        </div>
      </div>
      <div class="col-6">
        <div class="list-group">
          <ul>
            <li
              is="savedItem"
              v-for="result in $store.getters['list/getArticles']"
              v-bind:key="result.guid"
              v-bind:title="result.title"
              v-bind:link="result.link"
              v-bind:pubDate="result.pubDate"
              v-bind:source="result.source"
              v-bind:result="result"
              v-on:checked="$store.commit('list/removeArticle',$event)"

              class="list-group-item"
            >
            </li>
          </ul>
        </div>
<!--        <div class="text-center">-->
<!--          <template v-if="$store.getters['list/getArticles'].length > 0">-->
<!--            <button-->
<!--              type="button"-->
<!--              class="btn btn-primary "-->
<!--              v-on:click="step = 'step2'"-->
<!--            >Next Step</button>-->
<!--          </template>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import Vue from 'vue'
import NewsItem from '../main'
// import moment from 'moment'
import resultItem from '../components/resultItem'
import savedItem from '../components/savedItem'
import ArticleService from '../ArticleService'
import VueLuxon from 'vue-luxon'
Vue.use(VueLuxon)

export default {
  name: 'Search',
  components: {
    resultItem,
    savedItem
  },
  data: function () {
    return {
      results: [],
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    searchButton: async function () {
      let item = await ArticleService.getArticlesfromGoogle(document.getElementById('searchTopic').value)
      const parser = new DOMParser()
      item = parser.parseFromString(item, 'text/xml')
      this.startDate = document.getElementById('startDate').value
      this.endDate = document.getElementById('endDate').value
      this.results.length = 0
      // $.ajax({
      //   dataType: 'xml',
      //   url: 'https://news.google.com/news?q=' + document.getElementById('searchTopic').value + '&output=rss',
      //   async: false,
      //   success: function (data) {
      //     item = data
      //   }
      // })
      console.log(this.startDate)
      console.log(this.endDate)
      if (item && this.startDate && this.endDate) {
        console.log('entered start and end')
        for (let i = 0; i < 100; i++) {
          const returnItem = item.getElementsByTagName('item')[i]
          const resultItem = new NewsItem(
            returnItem.querySelector('title').textContent,
            returnItem.querySelector('link').textContent,
            returnItem.querySelector('pubDate').textContent,
            returnItem.querySelector('source').textContent,
            returnItem.querySelector('guid').textContent
          )
          var date1 = new Date(this.startDate)
          var date2 = new Date(this.endDate)
          var date = resultItem.pubDate.slice(5, 17)
          // var resultDate = this.$luxon(resultItem.pubDate, 'dd-mm-yyyy')
          // console.log(date)
          // var date1 = this.startDate.toISOString()
          // var date2 = this.endDate.toISOString()
          // var resultDate = this.date.toISOString()
          // var resultDate = moment(date).format('dd-mm-yyyy')
          var resultDate = new Date(date)
          // console.log(resultDate)
          if (date1 <= resultDate && resultDate <= date2) {
            console.log(resultDate)
            this.results.push(resultItem)
          }
        }
      } else {
        if (item) {
          console.log(item)
          for (let i = 0; i < 40; i++) {
            const returnItem = item.getElementsByTagName('item')[i]
            const resultItem = new NewsItem(
              returnItem.querySelector('title').textContent,
              returnItem.querySelector('link').textContent,
              returnItem.querySelector('pubDate').textContent,
              returnItem.querySelector('source').textContent,
              returnItem.querySelector('guid').textContent
            )
            this.results.push(resultItem)
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
